import { createElement } from 'react'
import type { WebExtension } from '@stagepost/web/extensions/types'
import { Marketing } from './marketing/Marketing'
import { LegalPage } from './legal/Legal'
import { Play } from './play'
import { countPageview, isCountedPage } from './analytics/pageviews'

/**
 * The last navigation `onNavigate` saw. `App` calls it again when the session
 * settles, and a page counted whatever the session (the guide, the policy
 * pages) must not count twice for that.
 */
let previous = { path: '', counted: false }

/** stagepost.io: the marketing site, the policy pages, Stageville's old path, and pageviews. */
export default {
  SignedOutHome: Marketing,
  signUpAction: 'Get early access',
  pages: [
    { path: '/privacy', render: () => createElement(LegalPage, { document: 'privacy' }) },
    { path: '/terms', render: () => createElement(LegalPage, { document: 'terms' }) },
    { path: '/play', prefix: true, render: () => createElement(Play) },
  ],
  onNavigate({ path, sessionStatus, passwordLink }) {
    const counted = isCountedPage(path, sessionStatus, passwordLink)
    if (counted && (path !== previous.path || !previous.counted)) countPageview()
    previous = { path, counted }
  },
} satisfies WebExtension
